export default __webpack_public_path__ + "static/media/assistencia-tecnica-em-pericias-judiciais-acordos.e4fc1420.jpg";